import { Component, Input } from '@angular/core';
import { ScansInterface } from '@monsido/modules/models/api/interfaces/scans.interface';

@Component({
    selector: 'mon-request-checker-html-component',
    templateUrl: 'html.html',
    styleUrls: ['./../../request-checker.scss'],
    standalone: false,
})

export class HtmlComponent {
    @Input() url: string;
    @Input() scan: ScansInterface;
    constructor () {}
}
